export const releasedEvent = (startDate, country) => ({
  '@type': 'PublicationEvent',
  startDate,
  location: {
    '@type': 'Country',
    name: country
  }
})
